import axios from 'axios'

// URL base dell'API per le segnalazioni, recuperato dall'env file

const SEGNALAZIONE_REST_API = process.env.REACT_APP_API_PREFIX + 'segnalazione'

const headers = { 'Content-Type': 'application/json' }

class SegnalazioniService {

    /**
     * Recupera tutte le segnalazioni disponibili nel sistema.
     * Effettua una richiesta GET a `/segnalazione/all`.
     *
     * @returns {Promise} - Una promessa che restituisce la lista di tutte le segnalazioni.
     */
    getAll() {
        return axios.get(SEGNALAZIONE_REST_API + "/all")
    }

    /**
     * Recupera tutte le segnalazioni associate a un determinato partecipante.
     * Effettua una richiesta GET a `/segnalazione/partecipante/{parId}`.
     *
     * @param {number} parId - L'ID del partecipante per cui recuperare le segnalazioni.
     * @returns {Promise} - Una promessa che restituisce la lista delle segnalazioni del partecipante specificato.
     */
    findByPartecipante(parId) {
        return axios.get(SEGNALAZIONE_REST_API + `/partecipante/${parId}`)
    }

    /**
     * Recupera tutte le segnalazioni associate a un determinato comune.
     * Effettua una richiesta GET a `/segnalazione/comune/{comId}`.
     *
     * @param {number} comId - L'ID del comune per cui recuperare le segnalazioni.
     * @returns {Promise} - Una promessa che restituisce la lista delle segnalazioni del comune specificato.
     */
    findByComune(comId) {
        return axios.get(SEGNALAZIONE_REST_API + `/comune/${comId}`)
    }

    /**
     * Salva o aggiorna un iniziativa nel sistema.
     * Effettua una richiesta POST a `/iniziativa/create` con i dati della segnalazione.
     *
     * @param {Object} iniziativa - Oggetto contenente i dettagli della segnalazione da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    creaSegnalazione(segnalazione) {
        return axios.post(SEGNALAZIONE_REST_API + "/create", segnalazione, headers)
    }
    /**
     * Salva una segnalazione nel sistema.
     * Effettua una richiesta POST a `/segnalazione/save` con i dati della segnalazione.
     *
     * @param {Object} iniziativa - Oggetto contenente i dettagli della segnalazione da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveSegnalazione(segnalazione) {
        return axios.post(SEGNALAZIONE_REST_API + "/save", segnalazione, headers)
    }
    /**
     * Recupera una segnalazione specifica in base al suo ID
     * Effettua una richiesta GET a `/segnalazione/{segId}`.
     *
     * @param {number} segId - L'ID della segnalazione da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli della segnalazione.
     */ 
    getSegnalazione(segId) {
        return axios.get(SEGNALAZIONE_REST_API + `/${segId}`)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const segnalazioniServiceInstance = new SegnalazioniService()
export default segnalazioniServiceInstance;